import WithToolTip from "@common/display/ToolTip"
import * as React from "react"
import { useHistory } from "react-router-dom"
import { Button } from "reactstrap"
import i18n from "./i18n"

const { t } = i18n

export default function InviteUser() {
  const history = useHistory()
  return (
    <WithToolTip tooltip={`${t("messages.invite_user_tooltip")}`}>
      <Button color="primray" onClick={() => history.push("/admin/user-admin-limited")} style={{ color: "white", marginRight: "8px" }}>
        {t("buttons.invite_user")}
      </Button>
    </WithToolTip>
  )
}
